import { fontSize, fontWeight } from "@mui/system";
import React from "react";
import AppointmentActionButtons from "./AppointmentActionButtons";
import { AppointmentActionButton } from "../styles";
import { StyledAppointmentCard } from "../styles";

const AppointmentCard = ({
  time,
  serviceName,
  serviceProviderName,
  patientName,
  theme,
}) => {
  return (
    <div>
      <StyledAppointmentCard theme={theme}>
        <div
          style={{
            fontWeight: "600",
            fontSize: "0.79rem",
            letterSpacing: "0px",
          }}
        >
          {time}
        </div>
        <div
          style={{
            fontWeight: "600",
            fontSize: "1.2rem",
            letterSpacing: "0px",
          }}
        >
          {serviceName}
        </div>
        <div
          style={{
            fontWeight: "600",
            fontSize: "0.79rem",
            letterSpacing: "0px",
          }}
        >
          {serviceProviderName}
        </div>
        <div
          style={{
            fontWeight: "600",
            fontSize: "0.70rem",
            letterSpacing: "0px",
          }}
        >
          {"Patient: " + patientName}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {/* <AppointmentActionButtons status="cancel" /> */}
        </div>
      </StyledAppointmentCard>
    </div>
  );
};

export default AppointmentCard;
